import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";

function _templateObject6() {
  const data = _taggedTemplateLiteral(["\n    width: 100%;\n    opacity: 0.5;\n    -webkit-appearance: none;\n    &:focus {\n        outline: none;\n    }\n    &::-webkit-slider-runnable-track {\n        width: 100%;\n        height: 8px;\n        cursor: pointer;\n        background: #999;\n        border-radius: 2px;\n        border: none;\n    }\n    &::-webkit-slider-thumb {\n        border: none;\n        height: 20px;\n        width: 50px;\n        border-radius: 15px;\n        background: #ffffff;\n        cursor: pointer;\n        -webkit-appearance: none;\n        margin-top: -6px;\n    }\n    &:focus::-webkit-slider-runnable-track {\n        background: #999;\n    }\n    &::-moz-range-track {\n        width: 100%;\n        height: 8px;\n        cursor: pointer;\n        background: #999;\n        border-radius: 2px;\n        border: none;\n    }\n    &::-moz-range-thumb {\n        border: none;\n        height: 20px;\n        width: 50px;\n        border-radius: 15px;\n        background: #ffffff;\n        cursor: pointer;\n    }\n    &::-ms-track {\n        width: 100%;\n        height: 8px;\n        cursor: pointer;\n        background: transparent;\n        border-color: transparent;\n        color: transparent;\n    }\n    &::-ms-fill-lower {\n        background: rgba(250, 250, 250, 0.11);\n        border: none;\n        border-radius: 2.6px;\n    }\n    &::-ms-fill-upper {\n        background: #999;\n        border: none;\n        border-radius: 2.6px;\n    }\n    &::-ms-thumb {\n        border: none;\n        height: 20px;\n        width: 50px;\n        border-radius: 15px;\n        background: #ffffff;\n        cursor: pointer;\n        height: 8px;\n    }\n    &:focus::-ms-fill-lower {\n        background: #999;\n    }\n    &:focus::-ms-fill-upper {\n        background: #999;\n    }\n"]);

  _templateObject6 = function () {
    return data;
  };

  return data;
}

function _templateObject5() {
  const data = _taggedTemplateLiteral(["\n    font-size: 12px;\n    max-height: calc(100vh - 65px);\n    overflow: auto;\n    color: white;\n    font-family: monospace;\n"]);

  _templateObject5 = function () {
    return data;
  };

  return data;
}

function _templateObject4() {
  const data = _taggedTemplateLiteral(["\n            right: 0;\n\n            cursor: e-resize;\n        "]);

  _templateObject4 = function () {
    return data;
  };

  return data;
}

function _templateObject3() {
  const data = _taggedTemplateLiteral(["\n            left: 0;\n            cursor: w-resize;\n        "]);

  _templateObject3 = function () {
    return data;
  };

  return data;
}

function _templateObject2() {
  const data = _taggedTemplateLiteral(["\n    position: fixed;\n    top: 0;\n    bottom: 0;\n    width: 30vw;\n    height: 100%;\n    z-index: 9;\n    ", "\n    ", "\n"]);

  _templateObject2 = function () {
    return data;
  };

  return data;
}

function _templateObject() {
  const data = _taggedTemplateLiteral(["\n    position: fixed;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    z-index: 10;\n    padding: 20px;\n    text-align: center;\n"]);

  _templateObject = function () {
    return data;
  };

  return data;
}

import React, { createRef, useEffect } from 'react';
import useLocalStorage from 'react-use/lib/useLocalStorage';
import styled, { css } from 'styled-components';
import { useKeyPress } from '../../hooks/useKeyPress';
export const Controls = props => {
  const timeline = props.timeline;
  const inputRef = createRef();

  const _useLocalStorage = useLocalStorage('help', false),
        _useLocalStorage2 = _slicedToArray(_useLocalStorage, 2),
        help = _useLocalStorage2[0],
        toggleHelp = _useLocalStorage2[1];

  useEffect(() => {
    const ref = inputRef.current;

    if (ref) {
      timeline.onUpdate((s, duration) => {
        ref.value = (s / duration * 100).toString();
      });
    }
  }, [inputRef, timeline]);
  const nextPress = useKeyPress(' ', 'ArrowRight', 'd');
  const prevPress = useKeyPress('Backspace', 'ArrowLeft', 'a');
  const helpPress = useKeyPress('h');
  const homePress = useKeyPress('Home', 's');
  useEffect(() => {
    if (nextPress) timeline.next();
    if (prevPress) timeline.back();
    if (helpPress) toggleHelp(!help);
    if (homePress) timeline.seek(0);
  }, [nextPress, prevPress, helpPress, homePress, timeline, toggleHelp, help]);

  const handleRangeEnd = event => {
    event.preventDefault();
    event.target.blur();
    timeline.next();
  };

  return React.createElement(React.Fragment, null, React.createElement(Container, null, React.createElement(Line, {
    ref: inputRef,
    type: "range",
    defaultValue: "0",
    step: "0.001",
    onMouseUp: handleRangeEnd,
    onTouchEnd: handleRangeEnd,
    onChange: e => timeline.seekByPercent(+e.target.value / 100)
  }), help && React.createElement(Steps, {
    style: {
      position: 'absolute',
      right: 10,
      bottom: 40,
      textAlign: 'left'
    }
  }, timeline.steps.map((step, i) => React.createElement("li", {
    key: step.id.toString() + i
  }, step.id.join('.'), step.options && step.options.title && " - ".concat(step.options.title))))), React.createElement(ClickableArea, {
    right: true,
    onClick: () => timeline.next()
  }), React.createElement(ClickableArea, {
    left: true,
    onClick: () => timeline.back()
  }));
};
const Container = styled.div(_templateObject());
const ClickableArea = styled.div(_templateObject2(), p => p.left && css(_templateObject3()), p => p.right && css(_templateObject4()));
const Steps = styled.ol(_templateObject5());
const Line = styled.input(_templateObject6());